import React from 'react';
import { Box } from '@mui/material';
import { Connector } from '@domain/connection/models/Connector';
import { APP_CONFIG } from '../../../../config/app.config';

interface MarketplaceConnectorImageProps {
  connector: Connector;
  shape?: 'square' | 'rounded';
  size?: 'small' | 'medium' | 'large';
}

const MarketplaceConnectorImage: React.FC<MarketplaceConnectorImageProps> = ({
  connector: connector,
  shape = 'square',
  size = 'medium',
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  const width = size === 'small' ? 48 : size === 'medium' ? 72 : 96;
  const height = shape === 'square' ? width : shape === 'rounded' ? width * 0.5 : width;

  return (
    <Box
      sx={{
        p: 1,
        width,
        height,
        borderColor: colors.border,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: '6px',
        bgcolor: 'background.paper',
      }}
    >
      <img
        src={connector.image}
        alt={connector.type}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        onError={(e) => {
          e.currentTarget.src = '/assets/images/ic_just_stock.png';
        }}
      />
    </Box>
  );
};

export default MarketplaceConnectorImage;
